/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @angular-eslint/directive-selector */
import {
  Directive,
  AfterViewInit,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription, map, filter } from 'rxjs';
import { countdown } from '@shared/utils';
import { MatDialog } from '@angular/material/dialog';
import { InactivityListenerComponent } from './inactivity-listener.component';
import { OnDestroy } from '@angular/core';
import { coerceNumberProperty } from '@angular/cdk/coercion';

/**
 *Directiva para controlar el estado de inactividad dentrol del elemento host
 *
 * @export
 * @class InactivityListenerDirective
 * @implements {AfterViewInit}
 * @implements {OnDestroy}
 */
@Directive({
  standalone: false,
  selector: '[inactivityListener]',
})
export class InactivityListenerDirective implements AfterViewInit, OnDestroy {
  @Output() onCloseSession = new EventEmitter<void>();
  @Output() onExtendSession = new EventEmitter<void>();

  /**
   *clase o clases css que seran aplicadas al dialogo mostrado
   *
   * @type {(string | string[])}
   * @memberof InactivityListenerDirective
   */
  @Input() overlayBackdropClass: string | string[] =
    'inactivity-listener__backdrop';

  /**
   *Clase o clases css que sean aplicadas al backdrop del dialogo mostrado
   *
   * @type {(string | string[])}
   * @memberof InactivityListenerDirective
   */
  @Input() overlayPanelClass: string | string[] = 'dialog-rounded-lg';

  private dialogIsOpen = false;
  private listenerDestroyed = false;
  private subscription!: Subscription;

  constructor(private dialog: MatDialog) {}

  /**
   *Escucha de eventos del objeto window para reiniciar la cuenta regresiva.
   *Evento click y evento mousemove
   * @memberof InactivityListenerDirective
   */
  @HostListener('window:click', ['$event'])
  @HostListener('window:mousemove', ['$event'])
  onWindowEventListener() {
    if (!this.dialogIsOpen && !this.listenerDestroyed) {
      this.initCountdown();
    }
  }

  ngAfterViewInit(): void {
    this.initCountdown();
  }

  /**
   *Tiempo de inactividad en minutos
   *
   * @readonly
   * @memberof InactivityListenerDirective
   */
  @Input()
  get inactivityMinutes() {
    return this._inactivityMinutes;
  }
  set inactivityMinutes(value: any) {
    this._inactivityMinutes = coerceNumberProperty(value);
  }
  private _inactivityMinutes = 0.1;

  /**
   *Tiempo de expiracion en minutos, este tiempo permite indicarle al usuario
   *en cuanto tiempo expirara la sesion
   * @readonly
   * @memberof InactivityListenerDirective
   */
  @Input()
  get expMinutes() {
    return this._expMinutes;
  }
  set expMinutes(value: any) {
    this._expMinutes = coerceNumberProperty(value);
  }
  private _expMinutes = 0.5;

  /**
   *Inicia una nueva cuenta regresiva y muestra
   *un dialogo de expiracion cuando la cuenta regresiva finaliza
   * @private
   * @memberof InactivityListenerDirective
   */
  private initCountdown() {
    if (this.subscription) {
      this.subscription?.unsubscribe();
    }

    this.subscription = countdown(this.inactivityMinutes)
      .pipe(
        map((countdown) => countdown.finished),
        filter((finished) => finished)
      )
      .subscribe((finished) => {
        if (finished) {
          this.dialogIsOpen = true;
          this.openOverlay();
        }
      });
  }

  /**
   *Abre un dialogo que cubre todo el viewport para mostrar al usuario un aviso
   *de expiracion de la sesion
   * @private
   * @memberof InactivityListenerDirective
   */
  private openOverlay() {
    this.dialog
      .open(InactivityListenerComponent, {
        data: { exp: this.expMinutes },
        disableClose: true,
        closeOnNavigation: false,
        backdropClass: this.overlayBackdropClass,
        panelClass: this.overlayPanelClass,
      })
      .afterClosed()
      .subscribe((extend) => {
        this.dialogIsOpen = false;

        if (extend) {
          this.onExtendSession.emit();
          this.initCountdown();
        } else {
          this.onCloseSession.emit();
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.listenerDestroyed = true;
  }
}
